export default __webpack_public_path__ + "static/media/image1.caef5a23.png";